<ng-container *ngIf="!dismissed">
    <div fxFlex fxLayoutAlign="stretch center">
        <mat-icon *ngIf="_getIconName()">{{_getIconName()}}</mat-icon>
        <div><ng-content></ng-content></div>
    </div>
    <button *ngIf="dismissible" mat-icon-button type="button" aria-label="Dismiss" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
</ng-container>